(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hospitality-tool-print-brand"] && !Shopify.designMode) return;
  try {
    // A separate document prevents the storefront's responsive/theme CSS from
  // controlling paper layout. Only the current worksheet and inputs are copied.
  document.addEventListener('havana:print-tool', async (event) => {
    const tool = event.target;
    const source = tool.querySelector('article');
    if (!source || !source.querySelector('.h1960-print-brand')) return;
    const status = tool.querySelector('[data-status]');
    document.querySelector('[data-havana-print-dialog]')?.remove();
    const dialog = document.createElement('dialog');
    dialog.setAttribute('data-havana-print-dialog', '');
    dialog.setAttribute('aria-label', 'Havana 1960 printable worksheet');
    dialog.style.cssText = 'position:fixed;inset:0;margin:auto;width:900px;max-width:96vw;height:94vh;max-height:94vh;padding:12px;background:#fff;color:#171512;border:1px solid #777;z-index:2147483647;';
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = 'Close print preview';
    close.style.cssText = 'display:block;margin:0 0 10px auto;padding:10px 16px;background:#2d4351;color:#fff;border:0;font:14px Arial,sans-serif;cursor:pointer;';
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => dialog.remove(), { once: true });
    const frame = document.createElement('iframe');
    frame.title = 'Havana 1960 printable worksheet';
    frame.style.cssText = 'display:block;width:100%;height:calc(100% - 50px);border:0;background:#fff;';
    dialog.append(close, frame);
    document.body.append(dialog);
    dialog.showModal();
    const preview = frame.contentWindow;
    document.body.classList.remove('h1960-printing');
    const doc = preview.document;
    doc.open();
    doc.write('<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"></head><body></body></html>');
    doc.close();
    doc.documentElement.lang = document.documentElement.lang || 'en';
    doc.title = (source.querySelector('h3')?.textContent.trim() || 'Hospitality worksheet') + ' — Havana 1960';

    const style = doc.createElement('style');
    style.textContent = `
      @page { size: auto; margin: 12mm; }
      * { box-sizing: border-box; }
      html { background: #edeae4; }
      body { margin: 0; color: #171512; font: 10pt/1.35 Arial, sans-serif; }
      .print-toolbar { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; justify-content: center; padding: 16px; font: 13px/1.4 Arial, sans-serif; }
      .print-toolbar button { padding: 12px 18px; background: #2d4351; color: #fff; border: 0; cursor: pointer; }
      .print-sheet { width: 186mm; margin: 0 auto 20px; padding: 8mm; background: #fff; overflow-wrap: anywhere; zoom: var(--preview-scale,1); }
      article { margin: 0; padding: 0; }
      h1,h2,h3,h4 { color: #171512; line-height: 1.15; text-transform: none; break-after: avoid; }
      h3 { font: 20pt/1.15 Georgia, serif; margin: 3mm 0; }
      h4 { font: 14pt/1.2 Georgia, serif; margin: 3mm 0 2mm; }
      p { margin: 2mm 0; orphans: 3; widows: 3; }
      small { font-size: 8pt; }
      [hidden] { display: none !important; }
      .h1960-print-brand--header { display: flex; align-items: center; justify-content: space-between; gap: 6mm; border-bottom: 2px solid #2d4351; padding-bottom: 3mm; margin-bottom: 4mm; break-inside: avoid; }
      .h1960-print-brand__logo img { display: block; width: 36mm; height: auto; max-height: 14mm; object-fit: contain; object-position: left; }
      .h1960-print-brand__contact { display: grid; text-align: right; font-size: 8pt; }
      .h1960-print-brand--footer { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 2mm; border-top: 1px solid #777; padding-top: 3mm; margin-top: 5mm; font-size: 8pt; break-inside: avoid; }
      .hh-folio__top,.hl-folio__top,.hp-ledger__top,.hc-ledger__top,.hs-board__top,.hr-ledger__top,.ht-docket__top { display: grid; grid-template-columns: minmax(0,1fr) minmax(36mm,auto); gap: 5mm; align-items: start; padding-bottom: 3mm; border-bottom: 1px solid #171512; break-inside: avoid; }
      .hh-folio__top p,.hl-folio__top p,.hp-ledger__top p,.hc-ledger__top p,.hs-board__top p,.hr-ledger__top p,.ht-docket__top p { font-size: 8pt; margin: 0; }
      .hh-property-key,.hl-total,.hp-result,.hc-difference,.hs-date,.hr-result,.ht-primary-total { border: 1px solid #2d4351; padding: 3mm; }
      .hh-property-key>*,.hl-total>*,.hp-result>*,.hc-difference>*,.hs-date>*,.hr-result>*,.ht-primary-total>* { display: block; }
      .hh-property-key strong,.hl-total strong,.hp-result strong,.hc-difference strong,.hs-date strong,.hr-result strong,.ht-primary-total strong { font: 20pt/1.15 Georgia,serif; margin: 1mm 0; }
      .hh-meta,.hl-meta,.hp-meta,.hc-meta,.ht-meta { display: flex; flex-wrap: wrap; gap: 2mm 6mm; font-size: 8.5pt; margin: 3mm 0; }
      table { border-collapse: collapse; width: 100%; table-layout: fixed; font-size: 9pt; margin: 3mm 0; }
      thead { display: table-header-group; }
      tbody { display: table-row-group; }
      tr { break-inside: avoid; }
      th,td { text-align: left; padding: 2mm; border-bottom: 1px solid #bbb; vertical-align: top; }
      th { border-bottom: 1px solid #171512; }
      .hl-table th:nth-child(1) { width: 33%; }
      .hl-table th:nth-child(2) { width: 35%; }
      .hl-table th:nth-child(n+3) { width: 16%; }
      .hl-table td:nth-child(n+3),.hl-table th:nth-child(n+3) { text-align: right; }
      .hl-category td,.hl-group td { font-weight: bold; padding-top: 3mm; }
      .hl-formula,.hc-disclaimer,.hs-disclaimer { font-size: 8pt; margin-top: 3mm; }
      .hh-group { margin: 4mm 0; }
      .hh-group__head { display: flex; align-items: baseline; justify-content: space-between; gap: 4mm; border-bottom: 1px solid #171512; break-after: avoid; }
      .hh-group__head span { font-size: 8pt; }
      .hh-tasks { list-style: none; padding: 0; margin: 0; }
      .hh-task { display: flex; gap: 3mm; align-items: flex-start; padding: 2mm 0; border-bottom: 1px solid #ddd; break-inside: avoid; }
      .print-checkbox { flex: 0 0 3.3mm; width: 3.3mm; height: 3.3mm; border: 1px solid #555; line-height: 3mm; text-align: center; margin-top: .3mm; font-size: 9pt; }
      .hh-task label { flex: 1; }
      .hh-task.is-complete label { text-decoration: line-through; }
      .hp-flow,.hs-forecast,.hs-metrics,.hr-metrics { display: grid; grid-template-columns: repeat(4,minmax(0,1fr)); margin: 3mm 0; border: 1px solid #777; break-inside: avoid; }
      .hp-numbers,.hc-volume,.hc-per-room,.ht-service-mix,.ht-totals { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); margin: 3mm 0; border: 1px solid #777; break-inside: avoid; }
      .hp-flow>div,.hp-numbers>div,.hc-volume>div,.hc-per-room>div,.hs-forecast>div,.hs-metrics>div,.hs-total>div,.hr-metrics>div,.ht-service-mix>div,.ht-totals>div,.ht-per-type>div { padding: 3mm; border-right: 1px solid #ccc; }
      .hp-flow>div>*,.hp-numbers>div>*,.hc-volume>div>*,.hc-per-room>div>*,.hs-forecast>div>*,.hs-metrics>div>*,.hs-total>div>*,.hr-metrics>div>*,.ht-service-mix>div>*,.ht-totals>div>*,.ht-per-type>div>* { display: block; }
      .hp-flow span,.hp-numbers span,.hc-volume span,.hc-per-room span,.hs-forecast span,.hs-metrics span,.hs-total span,.hr-metrics span,.ht-service-mix span,.ht-totals span,.ht-per-type span { font-size: 8pt; }
      .hp-flow strong,.hp-numbers strong,.hc-volume strong,.hc-per-room strong,.hs-forecast strong,.hs-metrics strong,.hr-metrics strong,.ht-service-mix strong,.ht-totals strong,.ht-per-type strong { font: 15pt/1.2 Georgia,serif; margin-top: 1.5mm; }
      .ht-ledger-wrap { overflow: visible; }
      .ht-ledger th:first-child,.ht-ledger td:first-child { width: 37%; text-align: left; }
      .ht-ledger th:not(:first-child),.ht-ledger td:not(:first-child) { text-align: right; }
      .ht-per-type { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); border: 1px solid #777; margin: 3mm 0; break-inside: avoid; }
      .ht-disclaimer { font-size: 8pt; }
      .hp-circulation p { font-size: 9pt; }
      .hc-comparison { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); border: 1px solid #777; margin: 3mm 0; break-inside: avoid; }
      .hc-option { padding: 3mm; }
      .hc-option+.hc-option { border-left: 1px solid #777; }
      .hc-option ul { list-style: none; margin: 3mm 0 0; padding: 0; }
      .hc-option li { display: flex; justify-content: space-between; gap: 3mm; padding: 1.5mm 0; border-top: 1px solid #ddd; font-size: 8.5pt; }
      .hc-cost { font: 21pt/1.2 Georgia,serif; }
      .hc-cost small { font: 8pt Arial,sans-serif; }
      .hs-roster { border: 1px solid #777; margin: 3mm 0; }
      .hs-roster__head,.hs-roster__row { display: grid; grid-template-columns: minmax(0,1fr) 20mm 28mm; gap: 3mm; padding: 2mm; border-bottom: 1px solid #bbb; break-inside: avoid; }
      .hs-roster__head { font-size: 8pt; font-weight: bold; }
      .hs-roster__row>span { display: flex; gap: 3mm; }
      .hs-roster__row>span>b { font-size: 8pt; }
      .hs-roster__row small { display: block; font-size: 8pt; }
      .hs-roster__row>strong { text-align: right; }
      .hs-total { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); border: 1px solid #777; margin: 3mm 0; break-inside: avoid; }
      .hs-total strong { font: 21pt/1.2 Georgia,serif; }
      .hs-alert { font-size: 8pt; border-left: 2px solid #777; padding-left: 3mm; }
      .hs-alert:empty { display: none; }
      .hr-table-wrap { overflow: visible; }
      .hr-table { min-width: 0; font-size: 7.5pt; }
      .hr-table th,.hr-table td { padding: 1.5mm; text-align: right; }
      .hr-table th:first-child,.hr-table td:first-child { width: 25%; text-align: left; }
      .hr-calendar-section { margin-top: 5mm; padding-top: 3mm; border-top: 1px solid #171512; }
      .hr-calendar__head { display: flex; justify-content: space-between; gap: 5mm; align-items: start; break-inside: avoid; }
      .hr-calendar__head h4 { margin: 0; }
      .hr-calendar__head p { font-size: 8pt; }
      .hr-calendar { display: grid; grid-template-columns: repeat(6,minmax(0,1fr)); border-top: 1px solid #777; border-left: 1px solid #777; margin-top: 3mm; }
      .hr-month { min-height: 18mm; padding: 2mm; border-right: 1px solid #777; border-bottom: 1px solid #777; break-inside: avoid; }
      .hr-month>* { display: block; }
      .hr-month span,.hr-month small { font-size: 7pt; }
      .hr-month strong { font: 10pt/1.2 Georgia,serif; margin: 2mm 0 1mm; }
      .hr-month--order { background: #eee8de; }
      .hr-formula,.hr-disclaimer { font-size: 7.5pt; }
      .print-assumptions { margin-top: 4mm; }
      .print-assumptions h4 { font: bold 10pt/1.2 Arial,sans-serif; }
      .print-assumptions dl { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 0 5mm; margin: 0; }
      .print-assumptions dl>div { display: flex; gap: 3mm; justify-content: space-between; border-bottom: 1px solid #ddd; padding: 1mm 0; font-size: 8pt; break-inside: avoid; }
      .print-assumptions dt { margin: 0; }
      .print-assumptions dd { margin: 0; font-weight: bold; text-align: right; }
      @media print {
        html,body { background: #fff; }
        .print-toolbar { display: none !important; }
        .print-sheet { width: auto; min-width: 0; max-width: none; margin: 0; padding: 0; zoom: 1 !important; }
      }
    `;
    doc.head.append(style);
    const toolbar = doc.createElement('div');
    toolbar.className = 'print-toolbar';
    const printButton = doc.createElement('button');
    printButton.type = 'button';
    printButton.textContent = 'Print / Save PDF';
    printButton.addEventListener('click', () => preview.print());
    const note = doc.createElement('span');
    note.textContent = 'For a clean copy, turn off browser headers and footers in print settings.';
    toolbar.append(printButton, note);
    doc.body.append(toolbar);

    const sheet = doc.createElement('main');
    sheet.className = 'print-sheet';
    const copy = doc.importNode(source, true);
    copy.removeAttribute('aria-live');
    copy.querySelectorAll('[hidden],script,form,button,.hh-progress,[class$="-actions"],[data-status]').forEach(node => node.remove());
    const sourceChecks = Array.from(source.querySelectorAll('.hh-task input[type="checkbox"]')).filter(input => !input.closest('[hidden]'));
    copy.querySelectorAll('.hh-task input[type="checkbox"]').forEach((input, index) => {
      const box = doc.createElement('span');
      box.className = 'print-checkbox';
      box.textContent = sourceChecks[index]?.checked ? '✓' : '';
      input.replaceWith(box);
    });
    copy.querySelectorAll('img').forEach(img => {
      const original = source.querySelector('.h1960-print-brand__logo img');
      if (original) img.src = original.currentSrc || original.src;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.loading = 'eager';
    });
    copy.querySelectorAll('[id],[for]').forEach(node => { node.removeAttribute('id'); node.removeAttribute('for'); });
    const footer = copy.querySelector('.h1960-print-brand--footer');
    if (!source.classList.contains('hh-folio')) {
      const assumptions = doc.createElement('section');
      assumptions.className = 'print-assumptions';
      const heading = doc.createElement('h4');
      heading.textContent = 'Settings used for this plan';
      const values = doc.createElement('dl');
      const controls = tool.querySelector('form');
      controls?.querySelectorAll('input:not([type="hidden"]),select').forEach(input => {
        if (input.closest('[hidden]')) return;
        const label = input.labels?.[0];
        if (!label) return;
        const labelCopy = label.cloneNode(true);
        labelCopy.querySelectorAll('input,select,small').forEach(node => node.remove());
        const title = labelCopy.textContent.replace(/\s+/g,' ').trim();
        if (!title) return;
        const value = input.type === 'checkbox' ? (input.checked ? 'Yes' : 'No') : input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent.trim() : input.value;
        const row = doc.createElement('div');
        const name = doc.createElement('dt');
        const detail = doc.createElement('dd');
        name.textContent = title;
        detail.textContent = value || '—';
        row.append(name,detail);
        values.append(row);
      });
      assumptions.append(heading,values);
      copy.insertBefore(assumptions,footer);
    }
    sheet.append(copy);
    doc.body.append(sheet);
    const fitPreview = () => sheet.style.setProperty('--preview-scale', Math.min(1, (frame.clientWidth - 16) / (186 * 96 / 25.4)));
    const observer = new ResizeObserver(fitPreview);
    observer.observe(frame);
    dialog.addEventListener('close', () => observer.disconnect(), { once: true });
    fitPreview();
    // Wait for the logo before opening the system dialog. A same-page frame
    // also works when popups are blocked, and the button supports reprinting.
    await Promise.all(Array.from(doc.images).map(img => img.decode().catch(() => {
      const fallback = doc.createElement('strong');
      fallback.textContent = 'Havana 1960';
      img.replaceWith(fallback);
    })));
    if (frame.isConnected) {
      if (status) status.textContent = 'Your printable worksheet is ready.';
      preview.focus();
      preview.requestAnimationFrame(() => preview.requestAnimationFrame(() => { if (frame.isConnected) preview.print(); }));
    }
  });
  } catch(e) { console.error(e); }
})();

})();
